import { client } from '@/utils/trpc'

export type UploadUrlResult = {
    id: string
    url: string
}

export const upload = async (
    data: Blob,
    {
        onProgress,
        getUploadUrl,
    }: {
        onProgress?: (progress: number) => void
        getUploadUrl?: () => Promise<UploadUrlResult>
    } = {}
) => {
    if (onProgress) {
        onProgress(0)
    }

    const { id, url } = getUploadUrl ? await getUploadUrl() : await client.misc.storage.getUploadUrl.query()

    const xhr = new XMLHttpRequest()
    const { success, status, statusText } = await new Promise(
        (resolve: (value: { success: boolean; status: number; statusText: string }) => void) => {
            if (onProgress) {
                xhr.upload.addEventListener('progress', (event) => {
                    onProgress(Math.round((event.loaded / event.total) * 100))
                })
            }
            xhr.addEventListener('loadend', () => {
                resolve({
                    success: xhr.readyState === 4 && xhr.status === 200,
                    status: xhr.status,
                    statusText: xhr.statusText,
                })
                if (onProgress) {
                    onProgress(100)
                }
            })
            xhr.open('PUT', url, true)
            xhr.setRequestHeader('Content-Type', data.type)
            xhr.send(data)
        }
    )

    if (!success) {
        throw new Error(`Error uploading data. Status: ${status} ${statusText}`)
    }

    return id
}
